import { useLocation, Redirect, useParams } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { PAGE_NAMES } from '../../../constants/Navigation';
import { ALL_PLAYLISTS_PATH, COMPLETED_PLAYLISTS_PATH, INCOMPLETE_PLAYLISTS_PATH } from '../constants/routes';
import PlaylistsTable from '../components/playlists/PlaylistsTable';
import PlaylistsTableFilters from '../components/playlists/PlaylistsTableFilters';
import { View } from 'foundations-components/components/View';
import { PageHeader } from '../../header/components/PageHeader';
import { FiltersCard } from '../../filters/components/FiltersCard';
import Card from '../components/common/Card';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { getStatus } from '../utils/playlistsUtils';
import { removePageParam } from '../utils/paginationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const tableNames = {
  INCOMPLETE: 'playlistsIncomplete',
  COMPLETED: 'playlistsCompleted'
};
export const RedirectToPlaylistsDefaultTab = () => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: ALL_PLAYLISTS_PATH
    })
  });
};
const MyTeamPlaylists = () => {
  const {
    playlistStatus
  } = useParams();
  const status = getStatus(playlistStatus);
  const location = useLocation();
  const tableName = status ? tableNames[status] : 'playlistsAll';
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM_PLAYLISTS
    });
  }, []);
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(PageHeader, {
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingSubTitles.MY_TEAM_PLAYLISTS"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingTitles.MY_TEAM_PLAYLISTS"
      })
    }), /*#__PURE__*/_jsx(FiltersCard, {
      paddingBlock: "400",
      paddingInline: "400",
      shouldRenderClearFilters: false,
      children: /*#__PURE__*/_jsxs(ButtonGroup, {
        children: [/*#__PURE__*/_jsx(RouterButton, {
          active: status === undefined,
          replace: true,
          to: {
            pathname: ALL_PLAYLISTS_PATH,
            search: removePageParam(location.search)
          },
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tabs.all"
          })
        }), /*#__PURE__*/_jsx(RouterButton, {
          active: status === 'COMPLETED',
          replace: true,
          to: {
            pathname: COMPLETED_PLAYLISTS_PATH,
            search: removePageParam(location.search)
          },
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tabs.completed"
          })
        }), /*#__PURE__*/_jsx(RouterButton, {
          active: status === 'INCOMPLETE',
          replace: true,
          to: {
            pathname: INCOMPLETE_PLAYLISTS_PATH,
            search: removePageParam(location.search)
          },
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tabs.incomplete"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(Card, {
      children: [/*#__PURE__*/_jsx(PlaylistsTableFilters, {
        tableName: tableName
      }), /*#__PURE__*/_jsx(PlaylistsTable, {
        tableName: tableName
      })]
    }, tableName)]
  });
};
export default MyTeamPlaylists;